import * as Sentry from '@sentry/angular';
import { environment } from '../../environments/environment';

export function initSentry() {
  Sentry.init({ dsn: environment.SENTRY_DNS, environment: environment.ENV_NAME });
}
